export const apidata = [
  // { value: "filter", label: "Posts" },
  // { value: "filter2", label: "Saptang" },
  // { value: "filter3", label: "E-Vidhur" },

  { value: "api/filter", label: "Social Media Report" },
  { value: "api/socialSentiments", label: "Sentiment Report" },
  { value: "news/report", label: "News Report" },
  { value: "api/images", label: "Image Report" },
  // { value: "fakenews/printFakeNews", label: "Fake News Report" },
];

export const platforms = [
  { value: "FACEBOOK", label: "Facebook" },
  { value: "TWITTER", label: "Twitter" },
  { value: "YOUTUBE", label: "YouTube" },
  // { value: "INSTAGRAM", label: "Instagram" },
  // { value: "KOO", label: "Koo" },
  { value: "THREADS", label: "Threads" },
  { value: "REDDIT", label: "Reddit" },
];

export const sections = [
  { value: "3(1)b(I)", label: " 3(1)b(i)" },
  { value: "3(1)b(II)", label: " 3(1)b(ii)" },
  { value: "3(1)b(III)", label: " 3(1)b(iii)" },
  { value: "3(1)b(IV)", label: " 3(1)b(iv)" },
  { value: "3(1)b(V)", label: " 3(1)b(v)" },
  { value: "3(1)b(VI)", label: " 3(1)b(vi)" },
  { value: "3(1)b(VII)", label: " 3(1)b(vii)" },
  { value: "3(1)b(VIII)", label: " 3(1)b(viii)" },
  { value: "3(1)b(IX)", label: " 3(1)b(ix)" },
  { value: "3(1)b(X)", label: " 3(1)b(x)" },
  { value: "3(1)b(XI)", label: " 3(1)b(xi)" },
];

export const languages = [
  { value: "English", label: "English" },
  { value: "Hindi", label: "Hindi" },
  { value: "Urdu", label: "Urdu" },
  { value: "Tamil", label: "Tamil" },
  { value: "Kannada", label: "Kannada" },
  { value: "Telugu", label: "Telugu" },
  { value: "Malayalam", label: "Malayalam" },
  { value: "Bengali", label: "Bengali" },
  { value: "Punjabi", label: "Punjabi" },
  { value: "other", label: "Other" },
];

export const sentiments = [
  { value: "positive", label: "Positive" },
  { value: "negative", label: "Negative" },
  { value: "neutral", label: "Neutral" },
];
export const sentimentUpdate = [
  { value: "Positive", label: "Positive" },
  { value: "Negative", label: "Negative" },
  { value: "Neutral", label: "Neutral" },
];
export const intensity = [
  { value: "high", label: "High" },
  { value: "medium", label: "Medium" },
  { value: "low", label: "Low" },
];

export const content = [
  { value: "Audio", label: "Audio" },
  { value: "Text", label: "Text" },
  { value: "Video", label: "Video" },
];

export const range = [
  { value: "7", label: "7 Days" },
  { value: "15", label: "15 Days" },
  { value: "30", label: "30 Days" },
  { value: "90", label: "90 Days" },
];
